// extracted by mini-css-extract-plugin
module.exports = {"mainFrameWrapper":"mainFrame_mainFrameWrapper__2xEVx","card":"mainFrame_card__ERcIS"};